import { HTTP } from "@/utils/http-common"
import { isNil } from "lodash"
export default {
  all: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/back-office/brands/simplified/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  list: function($, search = null, filters = {}, orders = {}, paginate = {}) {
    return new Promise((resolve, reject) => {
      const params = {
        ordering: orders,
        search: search,
        page: paginate.page || 1,
        page_size: paginate.page_size || 10
      }
      HTTP.get(
        `/perfumist/back-office/brands/${params ? "?" : ""}${Object.keys(params)
          .filter(key => !isNil(params[key]))
          .map(key => key + "=" + params[key])
          .join("&")}&${filters}`
      )
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  get: function($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/back-office/brands/${id}/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  create($, brand, id = null) {
    return new Promise((resolve, reject) => {
      let url = ""
      if (id) url = "/perfumist/back-office/brands/" + id + "/new-request/"
      else url = "/perfumist/back-office/brands/create-request/"
      HTTP.post(url, brand)
        .then(response => {
          // $.$store.commit("success", "New entry created")
          resolve(response)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  cancel($, id) {
    return new Promise((resolve, reject) => {
      HTTP.post("/perfumist/back-office/brands/" + id + "/cancel-request/")
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  editRequest: {
    approve($, brand_id, proposal) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          `/perfumist/back-office/brands/${brand_id}/approve-request/`,
          {
            data_approved: proposal.data
          }
        )
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    },
    reject($, brand_id, msg) {
      return new Promise((resolve, reject) => {
        HTTP.post(`/perfumist/back-office/brands/${brand_id}/reject-request/`, {
          message: msg
        })
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    }
  }
}
